<template>
    <el-dialog
            :visible="isVisible"
            @close="hide"
            :title="title"
            :destroy-on-close="true"
    >
        <loading v-if="!isInitialized"></loading>
        <contact-form
                ref="form"
                v-if="isInitialized"
                v-bind="formData"
                @stored="onStored"
        ></contact-form>
    </el-dialog>
</template>

<script>
  import BaseDialogFormWrapper from '../../components/dialog-form-wrapper';
  import ContactForm from '../../components/contact/form';
  import Loading from '../../components/loading';
  import eventBus from '../../event-bus';

  export default {
    extends: BaseDialogFormWrapper,

    components: {
      Loading,
      ContactForm,
    },

    computed: {
      /**
       * @return {string}
       */
      title() {
        if (!this.isInitialized) {
          return 'Loading ...';
        } else if (_.get(this.formData, 'model.id')) {
          return 'Edit Contact';
        }
      },


    },

    methods: {
      /**
       * @param {string|undefined} message
       */
      onStored({message}) {
        _.isString(message) && this.$message.success(message);
        this.hide();
        eventBus.$emit('refresh-message-list-items');
      },


    },

    created() {
      eventBus.$on('show-edit-message-list-item-dialog', this.show);
    },

    beforeDestroy() {
      eventBus.$off('show-edit-message-list-item-dialog', this.show);
    }
  }
</script>
